import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "./ui/drawer";
import { Input } from "./ui/input/input";
import { Button } from "./ui/button/button";
import { LocalStorageKeys } from "@/constants";
import { toast } from "./ui/use-toast";
import { useMerchant } from "@/contexts";
import _ from "lodash";
import { trackAmplitudeEvent } from "@/utils/amplitude";

const DrawerContext = createContext({
  isDrawerOpen: false,
  toggleDrawer: () => {},
  setIsDrawerOpen: _.noop,
});

export const useDrawer = () => useContext(DrawerContext);

export const DrawerProvider = ({ children }: any) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = useCallback(() => {
    setIsDrawerOpen((prevState) => !prevState);
  }, []);

  return (
    <DrawerContext.Provider
      value={{ isDrawerOpen, toggleDrawer, setIsDrawerOpen }}>
      {children}
    </DrawerContext.Provider>
  );
};

const UpiCheck: React.FC<any> = ({ children }) => {
  const [upi, setUpi] = useState("");
  const [loading, setLoading] = useState(false);
  const { isDrawerOpen, setIsDrawerOpen } = useDrawer();

  const { merchantDetails, merchantConfig } = useMerchant();

  const setUpiFunc = async () => {
    setLoading(true);
    localStorage.setItem(LocalStorageKeys.MERCHANT_UPI, upi);
    trackAmplitudeEvent("UPI_ID_SET");
    toast({ title: "Upi Set Successfully" });
    setIsDrawerOpen(false);
    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      const isLoggedIn = await localStorage.getItem(LocalStorageKeys.LOGGED_IN);
      const localMerchantUPI = await localStorage.getItem(
        LocalStorageKeys.MERCHANT_UPI,
      );
      if (
        (!localMerchantUPI || localMerchantUPI?.length == 0) &&
        Boolean(isLoggedIn) &&
        merchantDetails &&
        merchantDetails?.isRegistered &&
        merchantDetails?.isApproved
      ) {
        trackAmplitudeEvent("UPI_ID_PROMPT_SHOWN");
        setIsDrawerOpen(true);
      }
    })();
  }, [merchantDetails]);

  return (
    <>
      {children}
      <Drawer open={isDrawerOpen}>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>{"Set UPI"}</DrawerTitle>
            <DrawerDescription>
              {"Set your UPI to continue using app"}
            </DrawerDescription>
            <p className="font-satoshiBold text-[14px] tracking-wide text-text-primary">
              Current Account Number:{" "}
              <span className="font-bold">
                {merchantConfig?.redactedAccNum}
              </span>
            </p>
          </DrawerHeader>

          <div className="mx-3">
            <div className="mb-2 rounded border-[1px] border-yellow-500/30 bg-yellow-500/5 p-2">
              <ul>
                <li className="font-satoshiBold text-center text-[12px] tracking-wide text-yellow-500">
                  If UPI account number is different, inform the admin to update
                  it.
                </li>
              </ul>
            </div>

            <Input
              type={"text"}
              name={"upi_id"}
              value={upi}
              onChange={(event) => setUpi(event.target.value)}
              placeholder={"robert@okbank"}
            />
            <div className="mb-5 mt-2">
              <Button
                loading={loading}
                label={"Submit"}
                onClick={setUpiFunc}
                widthFull
              />
            </div>
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export const UpiCheckWrapper: React.FC<any> = ({ children }) => {
  return (
    <DrawerProvider>
      <UpiCheck>{children}</UpiCheck>
    </DrawerProvider>
  );
};
